<template>
  <div class="container search-main">
    <form action="">
      <div class="search-box">
        <input type="text" class="global-search desktop-only" placeholder="Search Videos..." v-model="searchText">
        <input type="text" class="global-search mobile-only" @input="mobileSearchVideos()"
                placeholder="Search Videos..." v-model="searchText">
        <button class="btn-search" @click.prevent="searchVideos()"><i class="fa fa-search" aria-hidden="true"></i>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
/**
 * Handles the search input.
 * Associated files: 'videoList.vue', 'videoPlayer.vue', 'video.js' and 'videos.blade.php'
 * @displayName Video Search
 */

export default {
  name: 'video-search',
  parent: 'video-content',

  data() {
    return {
      searchText: '',
    }
  },

  methods: {
    searchVideos() {
      this.$emit('search-input', this.searchText);
    }
  }
}
</script>